import DefaultValidation from '@/services/validations/DefaultValidation';
import Message from '@/models/Message';

export default class MotivoFotoValidation extends DefaultValidation{

    constructor(msgs) {
        super(msgs);
    }

    validate(model, refs) {
        let validated = true;
        let mf = model;

        if ( !mf.descricao ) {
            refs.descricaoInput.focusedOut = true;
            validated = false;
        }
        if ( !validated ){
            this.showMessage(new Message('alert', 'msg-campos-obrigatorios', true));
        }
        
        return validated;
    }

}